import DetailsContainer, { DetailsModal } from './DetailsContainer'

import reducer from './reducers'
import saga from './sagas'
import * as constants from './constants'
import * as actions from './actions'
import * as selectors from './selectors'

export default DetailsContainer
export { DetailsModal, reducer, saga, constants, actions, selectors }
